import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { RiLockPasswordLine } from 'react-icons/ri';
import { useLocation } from 'react-router-dom';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import useValidateTokenQuery from '../../hooks/useValidateTokenQuery';
import { ContentCard } from '../../layout/ContentCard';
import PageMetatags from '../../layout/PageMetatags';
import { PublicPageLayout } from '../../layout/PublicPageLayout';
import UserPasswordCard from './UserPasswordCard';

const UserPasswordOverviewPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token') as unknown as string;
  const validateTokenQuery = useValidateTokenQuery(token);
  const validToken = validateTokenQuery?.isSuccess;
  if (validateTokenQuery.isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <PublicPageLayout>
      <PageMetatags title={t('forms:password.label')} />
      {validToken ? (
        <UserPasswordCard token={token} />
      ) : (
        <ContentCard icon={<RiLockPasswordLine size={'40'} />} minH="fit-content" header={t('forms:password.label')}>
          <Box color={'error'}>{t('forms:password.invalid_token.message')}</Box>
        </ContentCard>
      )}
    </PublicPageLayout>
  );
};

export default UserPasswordOverviewPage;
